module.exports = require("./es-AR.d.ts");